import { render } from "./sheet-try-pro.vue?vue&type=template&id=c80fa1d2"
import script from "./sheet-try-pro.vue?vue&type=script&lang=js"
export * from "./sheet-try-pro.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__